module.exports = __webpack_public_path__ + "static/media/courier.9e52d2b5.svg";